/**
 * Form Controls Index
 * Export all form control components
 */
import TextField from './TextField'
import SelectField from './SelectField'
import MultiSelect from './MultiSelect'
import SwitchField from './SwitchField'
import CheckboxField from './CheckboxField'
import ReadOnlyField from './ReadOnlyField'
import AutoCompleteField from './AutoCompleteField'
import DateTimeField from './DateTimeField'
import DateRangeField from './DateRangeField'
import TimeRangeField from './TimeRangeField'
import RadioCardField from './RadioCardField'
import { FieldType } from '../types'

// Map field types to components
export const fieldComponents: Record<FieldType, React.FC<any>> = {
  [FieldType.TEXT]: TextField,
  [FieldType.SELECT]: SelectField,
  [FieldType.MULTISELECT]: MultiSelect,
  [FieldType.SWITCH]: SwitchField,
  [FieldType.CHECKBOX]: CheckboxField,
  [FieldType.READONLY]: ReadOnlyField,
  [FieldType.AUTOCOMPLETE]: AutoCompleteField,
  [FieldType.DATE]: DateTimeField, // Use DateTimeField for DATE type
  [FieldType.DATE_TIME]: DateTimeField, // Use DateTimeField for DATE_TIME type
  [FieldType.DATE_RANGE]: DateRangeField, // Use DateRangeField for DATE_RANGE type
  [FieldType.RADIO_CARD]: RadioCardField
}

export {
  TextField,
  SelectField,
  MultiSelect,
  SwitchField,
  CheckboxField,
  ReadOnlyField,
  AutoCompleteField,
  DateTimeField,
  DateRangeField,
  TimeRangeField,
  RadioCardField
}
